module.exports = __webpack_public_path__ + "img/4536d2f.jpg";